import React from 'react';
import PropTypes from 'prop-types';
import GridItem from '../GridItem';
import Button from '../Button';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';
import styles, { mainCls } from './styles';

const useStyles = createStyle(styles);

export default function ModalBody({
  className,
  content,
  full,
  fullScreen,
  children,
  version,
  title,
  inlineActions,
  close,
  open,
  ...props
}) {
  const classes = useStyles();
  const clsMain = makeClassName([
    className,
    classes[mainCls],
    'is-over--a',
    full ? classes[`${mainCls}--full`] : '',
    fullScreen ? classes[`${mainCls}--fullscr`] : '',
    version > 1 ? classes[`${mainCls}--DS`] : '',
  ]);

  /**
   * When modal has no footer, it can anyway have two standard buttons:
   * one is used to confirm the modal action
   * the other (optional) to just close the modal
   * 
   * inlineActions can basically pass just the button text as 'value'
   * of course the confirm button would better have an associated action :P
   */

  const defaultActions = [
    {
      action: () => {},
      className: 'tp-s--l tp-w--l',
    },
    {
      action: () => close(),
      border: 0,
      color: 'f5',
      bg: 'tr',
      className: 'mt--s tp-w--m',
      style: { fontSize: 14 },
    },
  ];

  const actions = inlineActions
    ? inlineActions.map(
      (act, index) => ({
        ...defaultActions[index],
        ...act,
      }),
    ) : null;

  return (
    <GridItem className={clsMain} behavior="stretch" {...props}>
      {
        /**
         * Standard modal header at scroll needs the modal title to be replicate in modal body:
         * it scrolls with the content, while the modal header title appears when modal body desappears
         */
        (version > 1 && title && typeof title === 'string')
          && (
            <p className={`${classes[`${mainCls}__title--DS`]} tp-w--l c-txt--f0${full ? ' pl--m' : ''}`}>
              {title}
            </p>      
          )
      }
      { content || children }
      {
        actions
          &&  (
            <div className={`${classes[`${mainCls}__btns`]} pt--m`}>
              {actions.map((action) => <Button key={action.value} {...action} />)}
            </div>
        )
      }
    </GridItem>
  );
};

ModalBody.propTypes = {
  /**
   * Component class
   */
  className: PropTypes.string,

  /**
   * Modal content
   */
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),

  /**
   * Full content
   */
  full: PropTypes.bool,

  /**
   * New standard layout
   */
  version: PropTypes.number,

  title: PropTypes.string,

  close: PropTypes.func,

  inlineActions: PropTypes.instanceOf(Array),
};

ModalBody.defaultProps = {
  className: '',
  content: '',
  full: false,
  version: 1,
  title: '',
  close: null,
  inlineActions: null,
};
